// extracted by mini-css-extract-plugin
var _1 = "CarouselButtons_arrowButton__3I9e5";
var _2 = "CarouselButtons_arrowButtonLeft__UkmCt";
var _3 = "CarouselButtons_arrowButtonRight__-Vte1";
var _4 = "CarouselButtons_container__8KcZA";
export { _1 as "arrowButton", _2 as "arrowButtonLeft", _3 as "arrowButtonRight", _4 as "container" }
